export const pl = {
  common: {
    play: 'Graj',
    next: 'Następne',
    back: 'Wróć',
    submit: 'Zatwierdź',
    score: 'Wynik',
    language: 'Język',
    loading: 'Ładowanie...',
    error: 'Błąd',
    anonymous: 'Anonimowy',
    leaderboard: 'Ranking',
  },
  home: {
    welcome: 'Witaj w EcoQuiz!',
    startGame: 'Rozpocznij grę',
    description: 'Sprawdź swoją wiedzę o ekologii i środowisku',
  },
  game: {
    question: 'Pytanie',
    timeLeft: 'Pozostały czas',
    correctAnswer: 'Prawidłowa odpowiedź!',
    wrongAnswer: 'Nieprawidłowa odpowiedź',
    seconds: 'sekund',
    hint: 'Podpowiedź',
    lifelines: 'Koła ratunkowe',
    totalTime: 'Całkowity czas',
    difficulty: 'Poziom trudności',
    tip: 'Podpowiedź',
    failedToFetch: 'Nie udało się pobrać pytania',
    failedToSubmit: 'Nie udało się wysłać odpowiedzi',
    failedToUseTip: 'Nie udało się użyć podpowiedzi',
    failedToUse5050: 'Nie udało się użyć 50/50',
    noMoreQuestions: 'Brak więcej pytań',
  },
  gameEnd: {
    congratulations: 'Gratulacje!',
    finalScore: 'Twój końcowy wynik',
    playAgain: 'Zagraj ponownie',
    backToHome: 'Wróć do strony głównej',
    greatJob: 'Świetna robota,',
    ecoWarrior: 'Eko Wojowniku!',
    points: 'punktów',
    time: 'Czas',
    yourName: 'Twoje imię (opcjonalne)',
    saveScore: 'Zapisz wynik',
    failedToSave: 'Nie udało się zapisać wyniku',
  },
  leaderboard: {
    ecoChampions: 'Eko Mistrzowie',
    rank: 'Miejsce',
    player: 'Gracz',
    score: 'Wynik',
    questions: 'Pytania',
    time: 'Czas',
    noEntries: 'Brak wyników',
    failedToFetch: 'Nie udało się pobrać rankingu',
  },
  footer: {
    supportedBy: 'Wspierane przez',
  },
  difficulty: {
    easy: "Łatwe",
    medium: "Średnie",
    hard: "Trudne",
    very_hard: "Bardzo trudne",
  }
} 